module.exports = __webpack_public_path__ + "img/anony_vip.4135ee84.png";